export default {
    SET_LOADING: "SET-LOADING"
}